import { _currentAppUserCountsCollection, _currentAppUserCountsCollection_xxx } from 'global/cnr/reducers/AppUserReducer';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { useCallback, useContext } from 'react';
import { ParentContext } from '../ParentContext';
import { onValue, ref } from 'firebase/database';
import { AppContext } from '../AppProvider';

export const useAppUsers = () => {

  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainRt } = app_state ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns

  const getDailyAppUserCount = useCallback(({ pathViews, callback, callbackU }) => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const path = `clients/${pathViews.clients}/events/${pathViews.events}/dailyUserCount`
    const pathU = `clients/undefined/events/undefined/dailyUserCount`
    const dbRef = ref(mainRt, path);
    const dbRefU = ref(mainRt, pathU);
    const unsubscribe = onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        let todaysCount = data?.[year]?.[month]?.[day]
        if (_.isNil(todaysCount)) { todaysCount = 0 }
        const dailyCounts = { todaysCount: todaysCount, fullCount: data }
        callback?.(dailyCounts);
      }
    });
    onValue(dbRefU, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        let todaysCount = data?.[year]?.[month]?.[day]
        if (_.isNil(todaysCount)) { todaysCount = 0 }
        const dailyCountsU = { todaysCount: todaysCount, fullCount: data }
        callbackU?.(dailyCountsU);
      }
    });
    return unsubscribe;
  }, []);

  const getCurrentAppUserCounts = useCallback(({ pathViews, callback }) => {
    const cb = (data) => {
      if (data) {
        callback && callback(data)
      }
    }
    const _refPathCau = createRefPath_event(pathViews, [_currentAppUserCountsCollection])
    database_fns.get_data({ refPath: _refPathCau, callback: cb, opts: { ignoreId: true } })
  }, []);

  const getCurrentAppUsers = useCallback(({ pathViews, callback }) => {
    const cb = (data) => {
      if (data) {
        callback && callback(data)
      }
    }
    const _refPathCau = createRefPath_event(pathViews, [_currentAppUserCountsCollection_xxx])
    database_fns.get_data({ refPath: _refPathCau, callback: cb, opts: { ignoreId: true } })
  }, []);

  return {
    getCurrentAppUserCounts,
    getCurrentAppUsers,
    getDailyAppUserCount,
  };
}
